
import { ManagerIcon } from '../../../assets/icons/icons';
import Popup from '../../Popup/Popup';
import './OrderErrorPopup.css';

function OrderErrorPopup({ isOpen, popupName, setOpen }) {
    return (
        <Popup
            isOpen={isOpen}
            popupName={popupName}
            setOpen={setOpen}
        >
            <div className='oreder-error-popup'>
                <ManagerIcon mainClassName={'oreder-error-popup__icon'} fillClassName={'oreder-error-popup__icon_fill'} />
                <p className="order-error-popup__text">Произошла ошибка при создании заказа</p>
                <p className="order-error-popup__subtext">Попробуйте еще раз позже или свяжитесь с технической поддержкой.</p>
            </div>
        </Popup>

    );
}

export default OrderErrorPopup